<template>
<div class="ow bg-white py-3 px-2 rounded border mb-4" v-if="auth.token && auth.login">
  <div class="pt-1">
    <div>
      <label class="text-primary h5">موجودی کیف پول :</label>
      <span class="px-2 prcolor-green font-weight creditVal prfont-weight">{{convertToPersian(numberFormat(String(auth.profile.sum_wallet)))}}</span>
      <span>تومان</span>
    </div>
    <div>
    <h6>جزئیات موجودی:</h6>
      <table class="table table-hover table-striped ">
        <thead>
          <tr>
            <th style="width: 10%;">ردیف</th>
            <th>نوع</th>
            <th>موجودی (تومان)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item,index in auth.profile.wallets" :key="index">
            <td>{{ index+1 }}</td>
            <td>{{ item.type }}</td>
            <td>{{ convertToPersian(String(item.amount)) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

    <div>
      <label class="prcolor-blue h3">افزایش اعتبار کیف پول :</label>
      <p class="mt-1 text-muted " style="font-size: 16px;font-weight: 700;">با شارژ موجودی حساب خود می‌توانید با سرعت و سهولت بیشتری خرید کنید.</p>
    </div>
    <span>مبلغ افزایش شارژ را وارد کنید : (تومان)</span>
  <div class="d-flex justify-content-between align-items-center credit-container">
    <div class="search-input mt-2 input-value" style="width:75%">
      <form autocomplete="off">
        <input type="tel"  v-model="increaseCash" class="form-control px-2 rounded border prcolor-text" style="direction:ltr;text-align:left" placeholder="لطفا مبلغ را اینجا وارد کنید" id="creditValueInput" >
      </form>
    </div>
    <div class="text-end input-value" style="width:25%">
        <button class="btn btn-success py-2 px-2 mt-2 input-value" style="width:75%" @click="addPay" v-if="loading">افزایش اعتبار</button>
        <btn-loading v-else class="btn btn-info py-1 px-2 mt-2 input-value" style="width:75%"/>
    </div>
  </div>
  <br>

  <div>
      <label class="prcolor-blue h3">برداشت اعتبار از کیف پول : </label>
      <!-- <p class="mt-1 text-muted" style="font-weight: 700;">میتوانید اعتبار کیف پولتان رابه حسابتان منتقل کنید.</p> -->
  </div>
   <span style="font-size: 14px;">در حال حاضر برداشت اعتبار غیرفعال میباشد.</span>
   <!--  <span style="font-size: 14px;">مبلغ درخواستی برای واریز به حسابتان را وارد نمایید :(تومان)</span>
  <div class="d-flex justify-content-between align-items-center credit-container">
    <div class="search-input mt-1 input-value" style="width:75%">
    <form autocomplete="off">
      <input type="tel"  v-model="decreaseCash"  class="form-control px-2 rounded border prcolor-text" style="direction:ltr;text-align:left" placeholder="لطفا مبلغ را اینجا وارد کنید" id="clearValueInput" >
      </form>
    </div>
    <div class="text-end input-value" style="width:25%">
      <button class="btn btn-outline-success py-2 px-2 mt-2 input-value" style="width:75%"  @click="addCachingTemp">تسویه کردن</button>
    </div>
  </div> -->
</div>
<div class="text-danger" v-else>
شمامجوز دسترسی به این صفحه را ندارید
</div>
</template>

<script setup>
import BtnLoading from '../../item/BtnLoading.vue';
import axios from "axios";
import { ref ,watch} from 'vue';
import { alertBox } from '@/composables/silverBox.js' 
import { convertToEnglish, convertToPersian,numberFormat,removeCommos } from "@/composables/digits.js";
import { useAuth } from '@/store/auth'
let auth = useAuth()
let increaseCash = ref('');
let decreaseCash = ref('');
let userWallet = ref(0)

let loading = ref(true)
auth.getToken()
for(let i in auth.profile['wallets']){
  userWallet.value += Number(removeCommos(auth.profile['wallets'][i].amount))
}
watch(increaseCash,() => {
  increaseCash.value = convertToEnglish(increaseCash.value);
  increaseCash.value = numberFormat(increaseCash.value.replaceAll(',',''))
  increaseCash.value = convertToPersian(increaseCash.value)
})
watch(decreaseCash,() => {
  decreaseCash.value = convertToEnglish(decreaseCash.value);
  decreaseCash.value = numberFormat(decreaseCash.value.replaceAll(',',''))
  decreaseCash.value = convertToPersian(decreaseCash.value)
})
async function addPay(){
  let amount = convertToEnglish(increaseCash.value).replaceAll(',','')
  if(amount == '' || Number(amount) < 5000){
    alertBox('حداقل مبلغ 5,000 تومان است.')
  }else{
  
    let allow = await new Promise((resolve) => {
    silverBox({
      title: {
        customIconClassName: "",
        text: "در صورت افزایش اعتبار، تنها میتوانید در خریدهایتان از آن استفاده کنید و مبلغ شارژ شده تحت هیچ شرایطی قابل بازگشت نیست.",
      },
      cancelButton: {
        bgColor: "white",
        borderColor: "white",
        className: "w-50 mx-auto text-danger",
        closeOnClick: true,
        loadingAnimation: true,
        onClick: () => resolve(false),
        showButton: true,
        text: "برگشت",
        textColor: "white",
      },
      confirmButton: {
        bgColor: "#198754",
        borderColor: "#198754",
        className: "w-50 mx-auto",
        closeOnClick: false,
        loadingAnimation: true,
        onClick: () => resolve(true),
        showButton: true,
        text: "افزایش اعتبار",
        textColor: "white",
      },
      direction: "rtl",
    });
  });

  if (allow) {
    try {
      loading.value = false
    const formData = new FormData()
    formData.append('cach',amount)
    formData.append('token',auth.token)

    axios.post('https://radap.ir/Backend/api/account/credit/add.php',formData)
    .then(res=>{
      window.location.href = res.data
    })
    } catch (error) {
      console.error("Request failed:", error);
    }
  }








   




  }
}
function addCachingTemp(){
  let amount = convertToEnglish(decreaseCash.value).replaceAll(',','')
  if(Boolean(Number(amount))){
    auth.getToken()
    let mainWallet = Number(removeCommos(auth.profile.wallets[0].amount))
    if(amount == ''){
        alertBox('حداقل مبلغ ۱,۰۰۰,۰۰۰ تومان است')
    }else if(amount < 1000000){
      alertBox('حداقل مبلغ ۱,۰۰۰,۰۰۰ تومان است')
    }else if(amount > mainWallet){
      alertBox('مبلغ درخواستی بیشتر از اعتبار کیف پولتان است')
    }else{
      document.getElementById('cashModalBTN').click()
      document.getElementById('clearAmount').value = amount
    }
  }else{
    alertBox('مبلغ وارد شده نادرست است')
  }
}
</script>
<style scoped>
@media (max-width: 500px) {
  .credit-container{
    flex-direction: column;
  }
  .input-value{
  width: 100% !important;  
  }
}
</style>